import { Injectable } from '@angular/core';
import { EDepositServiceCode } from '@common/models';
import { HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IContextualMenu } from '../common/models/contextual-menu.model';
import { HttpProviderService } from '../core/services/http-provider/http-provider.service';
import { ITermDepositDetails, ITermDepositProduct } from '../models/account-info.model';
import { DepositDetail } from '../models/Deposit-details.model';
import { DepositInfo } from '../models/Deposit.model';
import { ProvidehttpService } from '../providehttp.service';
import { CustomerService } from './customer.service';

@Injectable({
  providedIn: 'root'
})
export class DepositService {

  private _depositsInfo:Map<string, DepositInfo> = new Map<string, DepositInfo>();

  selectedDepositAccount:DepositInfo;

  contextualMenuList: IContextualMenu[] = [
    {
      id: 'D001',
      icon: 'deposit-open-new-deposit',
      name: 'CONTEXTULAMENU.openDeposit',
      title: 'OPENNEWDEPOSIT.title',
      path: ['shell', 'deposits', 'open-new-deposit'],
      desktopPath: ['home', 'transactions', 'deposits', 'open-new-deposit'],
      serviceCode : EDepositServiceCode.OPEN_NEW_DEPOSIT
    },
    // {
    //   id: 'D002',
    //   icon: 'deposit-change-maturity-instruction',
    //   name: 'Change maturity',
    //   title: 'Change Maturity',
    //   path: ['shell', 'deposits', 'change-maturity-instruction'],
    //   serviceCode : EDepositServiceCode.CHANGE_MATURITY_DEPOSIT
    // },
    // {
    //   id: 'D003',
    //   icon: 'deposit-redeem-deposit',
    //   name: 'Redeem deposit',
    //   title: 'Redeem Deposit',
    //   path: ['shell', 'deposits', 'redeem-deposit'],
    //   serviceCode : EDepositServiceCode.REEDEM_DEPOSIT
    // },
    // {
    //   id: 'D004',
    //   icon: 'deposit-closure-simulation',
    //   name: 'Deposit closure simulation',
    //   title: 'Deposit Closure Simulation',
    //   path: ['shell', 'deposits', 'deposit-closure-simulation'],
    //   serviceCode : EDepositServiceCode.CLOSURE_SIMULATION_DEPOSIT
    // }
  ];

  constructor(
    private httpService: ProvidehttpService,
    private _customerService: CustomerService,
    private _httpProvider:HttpProviderService
  ) { }

  getMenuList():IContextualMenu[]{
    return this.contextualMenuList;
  }

  getSelectedMenuData(menuId: string) {
    const selectedMenuItem = this.contextualMenuList.find(
      (item) => item.id == menuId
    );
    return selectedMenuItem;
  }

  /**
   * 
   * @param depositAccountNumber 
   * @returns depositInfo
   */
  fetchDepositInfo(depositAccountNumber: string): Observable<DepositInfo> {

    const httpRequest: HttpRequestPayload = {
      resource: "/deposit/" + depositAccountNumber,
      method: "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        this._depositsInfo.set(depositAccountNumber, res.body['deposit']);
        return this._depositsInfo.get(depositAccountNumber);
      }));
  }

  /**
   *
   * @param depositAccountNumber
   * @returns
   */
  getDepositDetails(depositAccountNumber: string): DepositDetail {
    let depositDetails: DepositDetail = this._customerService.getDepositDetails().find((item) => item.accountNumber == depositAccountNumber);
    return depositDetails;
  }

  getDepositInfo(depositAccountNumber: string): Observable<DepositInfo> {
    if (this._depositsInfo.has(depositAccountNumber)) {
      return of(this._depositsInfo.get(depositAccountNumber));
    } else {
      return this.fetchDepositInfo(depositAccountNumber).pipe(
        map(
          (res) => {
            return this._depositsInfo.get(depositAccountNumber)
          }
        )
      );
    }
  }
}
